import React from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import styles from '../../assets/scss/app.module.scss'
import {  Wrapper } from 'components'

import { NumHeading, Heading, customColor } from 'assets/globalComponent'
import {
    Enquestionlist,
    Enquestion,
    Resultbox,
    Resultboxheading,
    Colorindicator,
    Cidot,
    Citext,
    ProgressPercent
} from 'assets/engagementStyle'
import { Card, CardContent } from '@material-ui/core/'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Enprogressbar from './engprogress'
import { useSelector } from 'react-redux'
// import MarketShareChart from 'components/charts/MarketShareChart'
import StackedChart from 'components/charts/StackedChart'

export default function Engagement() {
    const { engagement_survey_result } = useSelector(state => state.tenantStats)
    const { counts } = useSelector(state => state.tenantStats)
    const { hide } = useSelector(state => state.tenantStats)
    const { brandingData, isLoadingBranding } = useSelector((state) => state.branding)
    const quizPoistiveTotal = item => {
        let totalPositive = 0
        item.questions.map(ques => {
            totalPositive = totalPositive + ques.satisfied + ques.very_satisfied
        })
        const positiveResponse = totalPositive / item.total_question
        return positiveResponse.toFixed() + ' %'
    }

    const quizResponse = item => {
        let strongly_postive = 0
        let positive = 0
        let neutrall = 0
        let stongly_negative = 0
        let negative = 0

        item.questions.map(ques => {
            strongly_postive = strongly_postive + ques.very_satisfied
            positive = positive + ques.satisfied
            neutrall = neutrall + ques.neutral
            stongly_negative = stongly_negative + ques.not_satisfied
            negative = negative + ques.slightly_satisfied
        })
        const very_satisfied = strongly_postive / item.total_question
        const satisfied = positive / item.total_question
        const neutral = neutrall / item.total_question
        const not_satisfied = stongly_negative / item.total_question
        const slightly_satisfied = negative / item.total_question

        const items = {
            very_satisfied,
            satisfied,
            neutral,
            not_satisfied,
            slightly_satisfied
        }

        return items
    }

    const positiveNegativeDistribution = () => {
        let strongly_postive = 0
        let positive = 0
        let neutrall = 0
        let stongly_negative = 0
        let negative = 0
        let total_question = 0

        engagement_survey_result.quiz.map(item => {
            item.questions.map(ques => {
                strongly_postive = strongly_postive + ques.very_satisfied
                positive = positive + ques.satisfied
                neutrall = neutrall + ques.neutral
                stongly_negative = stongly_negative + ques.not_satisfied
                negative = negative + ques.slightly_satisfied
            })
            total_question = total_question + item.total_question
        })

        const very_satisfied = strongly_postive / total_question
        const satisfied = positive / total_question
        const neutral = neutrall / total_question
        const not_satisfied = stongly_negative / total_question
        const slightly_satisfied = negative / total_question

        const items = {
            very_satisfied,
            satisfied,
            neutral,
            not_satisfied,
            slightly_satisfied
        }

        return items
    }
    return (
        <>{(hide || (!engagement_survey_result)) ? <>
            <Wrapper
                isPrinting={false}
                handlePrint={() => { }}
                title="Our Surveys"
                variant="h5"
            palette={{
                title: brandingData.pages.inclusionFeedback.pageHeaderText
            }}
            >
                No survey data has been processed at this time.
            </Wrapper>

        </> : <>
            <Grid container spacing={2} alignItems="center">
                <Grid item md={6} xs={12}>
                    <Box
                        className={`${styles.PageHeading} ${styles.Diversity}`}
                    >
                        <Typography variant="h1">Our Surveys</Typography>
                    </Box>
                </Grid>
            </Grid>
            <Box>
                <Heading variant="h3" component="h3">
                    Engagement Survey Overview
                </Heading>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={3}>
                            <Grid item xs="12">
                                <Card className={styles.CardOne}>
                                    <CardContent
                                        className={styles.CardOneContent}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <Heading variant="h6">
                                                    Surveys Issued
                                                </Heading>
                                                <NumHeading
                                                    variant="h2"
                                                    component="h2"
                                                >
                                                    {counts.surveys_issued}
                                                </NumHeading>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <Heading variant="h6">
                                                    Surveys Completed
                                                </Heading>
                                                <NumHeading
                                                    green
                                                    variant="h2"
                                                    component="h2"
                                                >
                                                    {counts.surveys_completed}
                                                </NumHeading>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs="12">
                                <Card className={styles.CardOne}>
                                    <CardContent
                                        className={styles.CardOneContent}
                                    >
                                        <Heading variant="h6">
                                            Positive/Negative Distribution
                                        </Heading>
                                        <Enprogressbar
                                            item={positiveNegativeDistribution()}
                                        />
                                        <Colorindicator>
                                            <Box>
                                                <Cidot
                                                    bgcolor={
                                                        customColor.Positive
                                                    }
                                                ></Cidot>
                                                <Citext>Positive</Citext>
                                            </Box>
                                            <Box>
                                                <Cidot
                                                    bgcolor={
                                                        customColor.DataProtected4
                                                    }
                                                ></Cidot>
                                                <Citext>Neutral</Citext>
                                            </Box>
                                            <Box>
                                                <Cidot
                                                    bgcolor={customColor.Red2}
                                                ></Cidot>
                                                <Citext>Negative</Citext>
                                            </Box>
                                        </Colorindicator>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card
                            className={styles.CardOne}
                            style={{ height: '100%' }}
                        >
                            <CardContent
                                style={{ height: '100%' }}
                                className={styles.CardOneContent}
                            >
                                <Heading variant="h6">Overall Trend</Heading>
                                <StackedChart />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
            <Resultbox>
                <Heading variant="h3" component="h3">
                    Engagement Survey Result
                </Heading>
                <Resultboxheading>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item md={6} sm={4} xs={4}>
                            <Typography component="h5" variant="h5">
                                Themes
                            </Typography>
                        </Grid>
                        <Grid item md={4} sm={4} xs={4}>
                            <Typography component="h5" variant="h5">
                                Distribution
                            </Typography>
                        </Grid>
                        <Grid item md={2} sm={4} xs={4}>
                            <Typography component="h5" variant="h5">
                                Positive
                                <br /> Response
                            </Typography>
                        </Grid>
                    </Grid>
                </Resultboxheading>
                <Grid container>
                    <Grid item xs="12">
                        {engagement_survey_result?.quiz.map(item => {
                            return (
                                <Accordion elevation={0}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Grid
                                            container
                                            alignItems="center"
                                            spacing={2}
                                        >
                                            <Grid item md={6} sm={12} xs={12}>
                                                <Typography
                                                    component="h4"
                                                    variant="h4"
                                                >
                                                    {' '}
                                                    {item.label}
                                                </Typography>
                                                <Typography
                                                    component="h5"
                                                    variant="h5"
                                                >
                                                    {' '}
                                                    {item.total_question}{' '}
                                                    Question
                                                </Typography>
                                            </Grid>
                                            <Grid item md={4} sm={12} xs={12}>
                                                <Enprogressbar
                                                    item={quizResponse(item)}
                                                />
                                            </Grid>
                                            <Grid item md={2} sm={12} xs={12}>
                                                <ProgressPercent>
                                                    {quizPoistiveTotal(item)}
                                                </ProgressPercent>
                                            </Grid>
                                        </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Enquestionlist>
                                            {item.questions.map(
                                                itemquestion => {
                                                    return (
                                                        <Enquestion>
                                                            <Grid
                                                                container
                                                                alignItems="center"
                                                                spacing={2}
                                                            >
                                                                <Grid
                                                                    item
                                                                    md={6}
                                                                    sm={12}
                                                                    xs={12}
                                                                >
                                                                    <Typography
                                                                        component="h4"
                                                                        variant="h4"
                                                                    >
                                                                        {
                                                                            itemquestion.question
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    md={4}
                                                                    sm={12}
                                                                    xs={12}
                                                                >
                                                                    <Enprogressbar
                                                                        item={
                                                                            itemquestion
                                                                        }
                                                                    />
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    md={2}
                                                                    sm={12}
                                                                    xs={12}
                                                                >
                                                                    <ProgressPercent>
                                                                        {' '}
                                                                        {(
                                                                            itemquestion.satisfied +
                                                                            itemquestion.very_satisfied
                                                                        ).toFixed()}{' '}
                                                                        %
                                                                    </ProgressPercent>
                                                                </Grid>
                                                            </Grid>
                                                        </Enquestion>
                                                    )
                                                }
                                            )}
                                        </Enquestionlist>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </Grid>
                </Grid>
            </Resultbox>
        </>}
        </>
    )
}
